import React, { Component } from 'react'
import styled from 'styled-components'
import Text from '../../components/Text'

const Box = styled.label`
  display: block;
  width: 100%;
  margin: 1.25rem 0;
  ${props => props.smallMargin && 'margin: 0.5rem 0;'}
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
`

const Label = styled.div`
  display: block;
  width: 100%;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  color: var(--gray);
  font-weight: 500;
  font-size: 0.8rem;
`

const SelectElt = styled.select`
  background: var(--off-white) url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAANlBMVEUAAAB3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3e23lafAAAAEXRSTlMAGBosLzY8Q1xppqivtbe+6OyZxOwAAABwSURBVDjL1ZM7EoAwCETxH03UcP/LWjgOEkh2LN32vQp2iVRCnqmVlZkXwFvGzevGw2uGcN94c8/Q3BolLw3LtRHYyyRCdoUowrifNqmnf2VIh03s0B22D5eEv8DfxH3AjcKdxK3Gu8DLwtvE63ZyAY22FseqhxpCAAAAAElFTkSuQmCC) no-repeat right 6px center;
  background-size: 12px 12px;
  display: block;
  padding: 0.75rem 1.5rem 0.75rem 0.5rem;
  width: 100%;
  border-radius: 0;
  border: 1px solid transparent;
  &:focus {
    border: 1px solid var(--blue);
  }
`

export default class Select extends Component {
  render() {
    const { allowBlank, label, children, smallMargin, ...props } = this.props

    return (
      <Box smallMargin={smallMargin}>
        {label &&
          <Label>
            <Text str={label} />
          </Label>
        }
        <SelectElt {...props}>
          {allowBlank && <option value='' />}
          {children}
        </SelectElt>
      </Box>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Select/Select.js